export function parseStringBoolean(value: string) {
  return value === 'True' || value === 'true';
}
